import React, {Component} from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import media from '../MediaQueries.js';
import styled from 'styled-components';

import { Collapse, Input, InputGroup, InputGroupButton, FormFeedback, Navbar, NavbarToggler, NavbarBrand, Nav, NavItem,
        NavLink, Container, Row, Col, Jumbotron, Button, ButtonGroup, Dropdown, DropdownToggle } from 'reactstrap';
import { Link } from 'react-router-dom';


export default class Locator extends Component {
  static propTypes = {
    googleMapsObject: PropTypes.object.isRequired,
    googleMapsLoaded: PropTypes.bool.isRequired
  }

  constructor(props) {
    super(props);

    this.state = {
      pattersonsLatitude: 41.8474617,
      pattersonsLongitude: -77.5351781,
      geoAllowed: false,
      latitude: 0,
      longitude: 0,
      accuracy: "",
      distanceInMiles: ""
    };
  }

  componentDidMount() {
    this.getLocation();

  }

  getLocation = () => { if(navigator.geolocation) { navigator.geolocation.getCurrentPosition(this.setLocationStateSuccess, this.setLocationStateError); } }

  setLocationStateSuccess = (position) => { 
    this.setState({ geoAllowed: true, latitude: position.coords.latitude, longitude: position.coords.longitude, accuracy: position.coords.accuracy},
     () => this.setDistanceInMiles() );
  }

  setLocationStateError = (err) => {
    switch(err.code) {
        case err.PERMISSION_DENIED:
            console.log("User denied the request for Geolocation.");
            break;
        case err.POSITION_UNAVAILABLE:
            console.log("Location information is unavailable.");
            break;
        case err.TIMEOUT:
            console.log("The request to get user location timed out.");
            break;
        case err.UNKNOWN_ERROR:
            console.log("An unknown error occurred.");
            break;
    }
  }

  setDistanceInMiles = () => {
    const service = new this.props.googleMapsObject.DistanceMatrixService();
    const originCoords = (`${this.state.latitude},${this.state.longitude}`);
    const pattersonsCoords = (`${this.state.pattersonsLatitude},${this.state.pattersonsLongitude}`);

    service.getDistanceMatrix({
      origins: [originCoords],
      destinations: [pattersonsCoords],
      travelMode: this.props.googleMapsObject.TravelMode.DRIVING,
      unitSystem: this.props.googleMapsObject.UnitSystem.IMPERIAL,
      avoidHighways: false,
      avoidTolls: false
    }, (response, status) => {
      if(status != this.props.googleMapsObject.DistanceMatrixStatus.OK) { 
        console.log(`Fetching DistanceMatrix has not-ok status. Status is: ${status}`); 
      }
      else {
        if(response.rows[0].elements[0].status === "ZERO_RESULTS") {
          console.log("No routes found from your current position to the destination.");
        }
        else {
          const origin = response.originAddresses[0];
          const destination = response.destinationAddresses[0];
          const distance = response.rows[0].elements[0].distance;
          const distanceInMiles = distance.text.substring(0, distance.text.length - 3);

          this.setState({ distanceInMiles }, () => this.setMap() );
        }
      }
    })
  }

  setMap = () => {
    const marker = new this.props.googleMapsObject.Marker({
      position: {lat: this.state.pattersonsLatitude, lng: this.state.pattersonsLongitude},
      title: "Patterson Farms",
      icon: { url: require("../media/bucket.png"), scaledSize: new this.props.googleMapsObject.Size(35, 35) }
    });

    const mapOptions = {
      center: new this.props.googleMapsObject.LatLng(this.state.latitude, this.state.longitude),
      zoom: 7
    };
    const map = new this.props.googleMapsObject.Map(document.getElementById("map"), mapOptions);
    marker.setMap(map);
  }

  render() {
    //const ExampleObject = ( <div></div> );

    return (
    	<FluidContainer fluid>
      
         <Helmet>
          <title>Get Directions - Patterson Maple Farms</title>
        </Helmet>
        <InternalContainer>
	        
      		{/*ExampleObject*/}
          <h1>Directions to Patterson Farms</h1>
      		<p>You can find Patterson Farms and all of our in-store specials, discount prices, tours, and smiling faces at the location on the map and address below.</p>
          <MilesAway_P>{`You are currently ${this.state.distanceInMiles} miles away.`}</MilesAway_P>
          <AddressRow>
            <Col xs="12" md="8">
              <MapDiv id="map"></MapDiv>
            </Col>
            
            
            <Col xs="12" md="4">
            <h3>Store Hours</h3>
              <AddressRow_P>M-F: 10AM to 5PM</AddressRow_P>
              <AddressRow_P>Sat: 9AM to 3PM</AddressRow_P>
              <AddressRow_P>Sun: Closed</AddressRow_P>
              <AddressRow_P>* Feb 1st to April 15 we may be open longer.</AddressRow_P>
              <AddressRow_P>* Holidays may affect these hours.</AddressRow_P>
              <AddressRow_P>* Feel free to contact us and ask!</AddressRow_P>

              <br/>

              <h3>Info</h3>
              <AddressRow_P>119 Patterson Road</AddressRow_P>
              <AddressRow_P>Westfield, PA 16950</AddressRow_P>
              <AddressRow_P>(814)-628-3751</AddressRow_P>
              <a target="_blank" href="https://www.google.com/maps/place/Patterson+Maple+Farms/@41.8474617,-77.5351781,18z/data=!3m1!4b1!4m5!3m4!1s0x89ce20414219c9bb:0x99fe70447a64bc64!8m2!3d41.8474601!4d-77.5343149">
                Google Maps Directions</a>
              <LeavesPic src={require("../media/leavespng1.png")}></LeavesPic>
            </Col>
          
          </AddressRow>
        </InternalContainer>
      </FluidContainer>
		);
	}
}

const LeavesPic = styled.img`
  width: 80px;
  float: right;


  ${media.sm`
    position: absolute;
    bottom: 0;
    right: 0;
  `}
`;

const MapDiv = styled.div`
  width: 100%;
  height: 500px;
  margin-bottom: 20px;
  ${media.md`margin-bottom: 0;`}
  
`;

const MilesAway_P = styled.p`

`;



const AddressRow = styled(Row)`
  
`;

const AddressRow_P = styled.p`
  margin: 0;
`;

const FluidContainer = styled(Container)`
    padding: 30px 0 20px 0!important;
  `;
const InternalContainer = styled(Container)` h1 {color: black!important;} `;

//const Div_s = styled.div``;

/*
const ListViewContainer = styled(({ listSelected, ...rest }) => <Container {...rest} />)`
	display: ${a => a.listSelected ? "block" : "none"};
`;
*/



// WEBPACK FOOTER //
// ./src/pages/Locator.js